var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.154 16.988a1 1 0 0 0 .149-.05c.037-.018 2.21-2.036 4.826-4.485 3.575-3.346 4.772-4.477 4.814-4.551.05-.087.057-.123.057-.278s-.008-.192-.056-.28a.66.66 0 0 0-.58-.335c-.306-.002.14-.396-4.862 4.286L12 15.51l-4.502-4.214C2.495 6.613 2.942 7.007 2.636 7.01a.66.66 0 0 0-.58.335c-.049.088-.056.124-.056.28 0 .155.007.191.057.278.042.074 1.24 1.207 4.814 4.552 3.88 3.632 4.776 4.461 4.857 4.494a.85.85 0 0 0 .426.04",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDown;